import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { alpha, useTheme, experimentalStyled as styled } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
const ButtonStyle = styled(Button)(({ theme, styleProps, }) => {
    const { color, variant } = styleProps;
    const styleContained = (color) => ({
        color: theme.palette[color].contrastText,
        backgroundColor: theme.palette[color].main,
        '&:hover': {
            backgroundColor: theme.palette[color].dark,
        },
    });
    const styleOutlined = (color) => ({
        color: theme.palette[color].main,
        border: `1px solid ${alpha(theme.palette[color].main, 0.48)}`,
        '&:hover': {
            border: `1px solid ${theme.palette[color].main}`,
            backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
        },
    });
    const styleText = (color) => ({
        color: theme.palette[color].main,
        '&:hover': {
            backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
        },
    });
    return {
        ...(variant === 'contained' && { ...styleContained(color) }),
        ...(variant === 'outlined' && { ...styleOutlined(color) }),
        ...(variant === 'text' && { ...styleText(color) }),
    };
});
export const MButton = forwardRef(({ color = 'primary', variant = 'text', children, ...other }, ref) => {
    const theme = useTheme();
    if (color === 'inherit' || color === 'primary' || color === 'secondary') {
        return (_jsx(Button, Object.assign({ ref: ref, color: color, variant: variant }, other, { children: children }), void 0));
    }
    return (_jsx(ButtonStyle, Object.assign({ ref: ref, variant: variant, styleProps: { color, variant }, theme: theme }, other, { children: children }), void 0));
});
//# sourceMappingURL=MButton.js.map